import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { AppState } from '@cpd-app/state';

import * as DeviceActions from './device.actions';
import * as DeviceSelectors from './device.selectors';

@Injectable({
  providedIn: 'root',
})
export class DeviceFacade {
  readonly isExtraSmall$ = this.store.pipe(
    select(DeviceSelectors.selectIsExtraSmall)
  );
  readonly isLessThanMedium$ = this.store.pipe(
    select(DeviceSelectors.selectIsLessThanMedium)
  );
  readonly isMedium$ = this.store.pipe(select(DeviceSelectors.selectIsMedium));
  readonly isLarge$ = this.store.pipe(select(DeviceSelectors.selectIsLarge));
  readonly isMobile$ = this.store.pipe(select(DeviceSelectors.selectIsMobile));

  readonly isGreaterThanExtraSmall$ = this.store.pipe(
    select(DeviceSelectors.selectIsGreaterThanExtraSmall)
  );

  readonly isSmallerThanValue$ = (smallerThan: number) =>
    this.store.pipe(
      select(DeviceSelectors.selectIsSmallerThanValue(smallerThan))
    );

  constructor(private store: Store<AppState>) {}

  setDeviceWidthHeight(deviceWidth: number, deviceHeight: number) {
    this.store.dispatch(
      DeviceActions.setDeviceWidthHeight({ deviceWidth, deviceHeight })
    );
  }
}
